import React, { useState } from 'react';

import { Button } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  Close
} from "@mui/icons-material";

import { ModelBase } from "@models";
import { 
  Character,
  CharacterFeatureSource,
  CharacterFeat,
  Feat,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";

import SelectObjectIndex from "@dndComponents/select/SelectObjectIndex";
// import ButtonBox from '../../../../../components/input/buttons/ButtonBox';
import CharacterFeatureSourcesOuter from "@dndComponents/character/features/CharacterFeatureSourcesOuter";
import AddButton from "@components/input/buttons/AddButton";

interface Props {
  character: Character;
  onChange: (changed: Character, do_main: boolean) => void;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CharacterExtraFeatInput({
  character,
  onChange
}: Props) {
  // const [fetched, setFetched] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [reloading, setReloading] = useState(false);
  const [new_feat, setNewFeat] = useState(false);
  const [filter, setFilter] = useState<any>({ });
  const [expanded_feat_id, setExpandedFeatID] = useState(character.extra_feats.length === 1 ? character.extra_feats[0].true_id : "");
  const [requirements, setRequirements] = useState<boolean | null>(null);
  // const [swapping, setSwapping] = useState<Feat | null>(null);
  const [change_time, setChangeTime] = useState(0);

  const updateFilter = (changed: any = {}) => {
    const new_filter = {...changed};

    if (new_filter.requirements === undefined && requirements !== null) {
      setRequirements(null);
      // is_changed = true;
    } else if (requirements !== new_filter.requirements && (requirements !== null || new_filter.requirements !== undefined)) {
      setRequirements(new_filter.requirements);
      // is_changed = true;
    }
    delete new_filter.requirements;

    setFilter(new_filter);
  }

  const renderAddAnotherFeat = () => {
    return (
      <div style={{ float: "right" }}>
        <AddButton
          label="Add Another Feat"
          onClick={() => {
            setNewFeat(true);
          }} 
        />
      </div>
    );
  }

  const char_feat_ids = [
    ...character.feats.map(o => o.source_id),
    ...character.feats.map(o => o.source?.variant_of_id??"")].filter(o => o !== "");
  // if (swapping) {
  //   return (
  //     <Grid container spacing={0} direction="row">
  //       <Grid item xs={12}>
  //         <Button variant="contained" color="primary"
  //           onClick={() => {
  //             setSwapping(null);
  //           }}>
  //           Cancel Swap
  //         </Button>
  //       </Grid>
  //       <Grid item xs={12}>
  //         <SelectObjectIndex
  //           data_type="feat"
  //           flat
  //           quick_fields={["feat_tier","ability_scores"]}
  //           extra_filter={(o: ModelBase) => {
  //             return o instanceof Feat && o.variant_group_id === swapping.variant_group_id && common_util.any_overlaps(o.source_book_ids, character.character_options.source_books); // && !character.character_options.blocked_feats.includes(o._id);
  //           }}
  //           disableObj={(o: ModelBase) => {
  //             if (o._id === swapping._id) {
  //               return { disabled: true, reasons: "Current" };
  //             }
  //             return { disabled: false, reasons: "" };
  //           }}
  //           filter={filter}
  //           updateFilter={updateFilter}
  //           onClick={(obj: ModelBase) => {
  //             const char_feat = character.feats.find(o => o.source_id === swapping._id);
  //             if (obj instanceof Feat && char_feat) {
  //               char_util.swapVariant(character, obj, char_feat).then(res => {
  //                 onChange(character, false);
  //                 setSwapping(null);
  //                 setExpandedFeatID(char_feat.true_id);
  //               });
  //             }
  //           }}
  //         />
  //       </Grid>
  //     </Grid>
  //   );
  // } else 
  if (character.extra_feats.length === 0 || new_feat) {
    return (
      <Grid container spacing={0} direction="row">
        { new_feat && 
          <Grid
            size={{
              xs: 12
            }}>
            <Button variant="contained" color="primary"
              onClick={() => {
                setNewFeat(false);
              }}>
              Cancel Add
            </Button>
          </Grid>
        }
        <Grid size={12}>
          <SelectObjectIndex
            data_type="feat"
            quick_fields={["feat_tier","ability_scores","tags"]}
            character={character}
            filter={filter}
            updateFilter={updateFilter}
            extra_filter={(obj) => {
              if (requirements !== null) {
                let disabled = false;
                // let reasons = "";
                if (obj instanceof Feat) {
                  // reasons = "";
                  // Check for variants that character already has
                  if (char_feat_ids.includes(obj._id) || char_feat_ids.includes(obj.variant_of_id)) {
                    // Some Feats are repeatable though, so if it's repeatable check if they have the actual Feat.  Variants should still be disabled though.
                    if (!obj.repeatable || character.feats.filter(o => o.source_id === obj._id).length === 0) {
                      disabled = true;
                      // reasons = "You already have a variant of this Feat";
                    }
                  }
                }
                return disabled !== requirements;
              }
              return true;
            }}
            onClick={ async (obj: ModelBase) => {
              if (obj instanceof Feat) {
                await api.loadObject(obj);
                const char_feat = new CharacterFeat();
                await char_feat.copy_source({ char: character, feature_source: obj });
                character.extra_feats.push(char_feat);

                onChange(character, false);
                setNewFeat(false);
                setExpandedFeatID(char_feat.true_id);
              }
            }}
            disableObj={(obj: ModelBase) => {
              let disabled = false;
              let reasons = "";
              if (obj instanceof Feat) {
                reasons = char_util.fitLimits(character, obj.limitations, "feat", obj._id);
                if (reasons === "true") {
                  reasons = "";
                  // Check for variants that character already has
                  if (char_feat_ids.includes(obj._id)) {
                    // Some Feats are repeatable though, so if it's repeatable check if they have the actual Feat.  Variants should still be disabled though.
                    if (!obj.repeatable || character.feats.filter(o => o.source_id === obj._id).length === 0) {
                      disabled = true;
                      reasons = "You already have this Feat";
                    }
                  } else if (char_feat_ids.includes(obj.variant_of_id)) {
                    disabled = true;
                    reasons = "You already have a variant of this Feat";
                  }
                } else {
                  disabled = true;
                }
              }
              return { disabled, reasons };
            }}
          />
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          { renderAddAnotherFeat() }
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CharacterFeatureSourcesOuter
            char={character}
            sources={character.extra_feats}
            change_time={change_time}
            expanded_cfs_id={expanded_feat_id}
            extra_cfs_header_control={(cfs: CharacterFeatureSource) => {
              if (cfs instanceof CharacterFeat) {
                const char_feat = cfs;
                return (
                  <Grid container spacing={0} direction="row">
                    <Grid
                      size={{
                        xs: 9
                      }}>
                      {/* { char_feat.source && char_feat.source.max_level > 1 &&
                        <SelectStringBox 
                          name="Level"
                          options={CHARACTER_LEVELS}
                          value={`${char_feat.level}`}
                          onChange={(value: string) => {
                            const level: number = +value;
                            char_util.changeSourceLevel(character, char_feat.source_id, level);
                            char_util.repopulateCharFeatureBases(character).then(() => {
                              onChange(character, false);
                              setChangeTime(common_util.get_time_number());
                            });
                          }}
                        />
                      } */}
                    </Grid>
                    <Grid
                      size={{
                        xs: 3
                      }}>
                      <Close style={{ cursor: "pointer" }}
                        onClick={() => {
                          char_util.removeCharFeatureBasesFor(character, char_feat);
                          character.extra_feats = character.extra_feats.filter(o => o.source_id !== char_feat.source_id);
                          character.spells = character.spells.filter(o => o.source_type !== "Feat" || o.source_id !== char_feat.source_id);
                          onChange(character, false);
                          setNewFeat(false);
                          setExpandedFeatID("");
                        }} 
                      />
                    </Grid>
                  </Grid>
                );
              }
              return undefined;
            }}
            // extra_cfs_controls={(cfs: CharacterFeatureSource) => {
            //   if (cfs instanceof CharacterFeat) {
            //     const char_feat = cfs;
            //     const valid_variants = char_feat.source ? char_feat.source.variant_group.filter(o => common_util.any_overlaps(o.source_book_ids, character.character_options.source_books)) : []; // && !character.character_options.blocked_feats.includes(o._id)) : [];
            //     if (char_feat.source && valid_variants.length > 1) {
            //       return [
            //         <Grid item xs={12} key="change_variant">
            //           <ButtonBox 
            //             name="Change Variant"
            //             onClick={() => {
            //               setSwapping(char_feat.source);
            //             }}
            //           />
            //         </Grid>
            //       ];
            //     }
            //   }
            //   return [];
            // }}
            // extra_bottom_controls={() => {
            //   // debugger;
            //   return [];
            // }}
            // cfs_sort={(a: CharacterFeatureSource, b: CharacterFeatureSource) => {
            //   if (a instanceof CharacterFeat && b instanceof CharacterFeat) {
            //     return a.position > b.position ? 1 : -1;
            //   }
            //   return 1;
            // }}
            // onChange={() => {
            //   onChange(character, false);
            // }}
            onCFSSelect={(cfs: CharacterFeatureSource | undefined) => {
              setExpandedFeatID(cfs ? cfs.true_id : "");
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
      </Grid>
    );
  }
}
